import { Divider, Typography } from "@mui/material";
import React from "react";
import classes from "./PlayerList.module.css";
import Brightness1Icon from "@mui/icons-material/Brightness1";

const PlayerList = ({ style, name, icon, showDivider = false }) => {
  return (
    <>
      <div
        style={{ ...style }}
        className={classes.contentContainer}
      >
        <div className={classes.itemsContainer}>
          {/* <Brightness1Icon /> */}
          <p className={classes.text}>{name}</p>
        </div>
        {showDivider && <Divider sx={{
          width: "85%",
          height: '1px',
          fontWeight: 600,
          alignSelf: 'center',
          backgroundColor: '#080B2A',
          position: 'absolute',
          bottom: 0
        }} />}
      </div>
    </>
  );
};

export default PlayerList;
